import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import "../.././src/pages/Goldpage/goldify.css";
import { historyInvoiceApi } from "../redux/features/history/historyInvoiceSlice";
import { spotGoldInvoiceApi } from "../redux/features/history/spotGoldInvoiceSlice";
import Loader from "../components/Loader";
// import { goldFDCloseConfirmApi } from "../redux/features/goldFD/goldFDCloseConfirmSlice";
// import { goldFDCloseApi } from "../redux/features/goldFD/goldFDCloseSlice";
import CustomButton from "../components/CustomButton";

const HistoryInvoice = () => {
  const { id: transactionID } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();

  const { company, type } = location?.state?.item || {};

  const { data, error, isLoading } =
    useSelector((state) => state.historyInvoiceSlice) || {};

  const historyData = data?.data;

  useEffect(() => {
    if (type === "SPOT GOLD") {
      if (location?.state?.item?.transactionId) {
        dispatch(spotGoldInvoiceApi(location?.state?.item?.transactionId));
      }
    } else {
      const payload = {
        transactionId: transactionID,
        type: location?.state?.item?.transaction_type,
        company: location?.state?.item?.company,
      };
      dispatch(historyInvoiceApi(payload));
    }
  }, [dispatch, type, transactionID]);

  // ================================SPOT GOLD INVOICE API====================================

  const spotGoldSliceResponse = useSelector(
    (state) => state.spotGoldInvoiceSlice.data.data
  );

  const {
    invoiceId,
    invoicePath,
    preTaxAmount,
    quantity,
    totalAmount,
    totalTaxAmount,
    transactionId: historyTransactionId,
    uniqueId: historyUniqueId,
    metalRate,
  } = historyData?.[0] || {};

  const [updatedInvoicePath, setUpdatedInvoicePath] = useState("");

  useEffect(() => {
    setUpdatedInvoicePath("");
    const invoicePath = historyData?.[0]?.invoicePath || "";

    // Check if the invoice path includes "http"
    if (invoicePath.includes("http")) {
      setUpdatedInvoicePath(invoicePath);
    } else if (invoicePath) {
      const baseURL = process.env.REACT_APP_BASE_URL || "";

      const fullPath = `${baseURL}${invoicePath}`;
      setUpdatedInvoicePath(fullPath);
    }

    // dispatch(historyInvoiceReset());
  }, [historyData?.[0]?.invoicePath]);

  let goldLease,
    schemaName,
    userAccountName,
    startDate,
    endDate,
    tenure,
    remaingTenure,
    interestRate,
    tdsRate,
    uniqueId,
    transactionId,
    status;

  if (location.state.type === "fd") {
    ({
      goldLease,
      schemaName,
      userAccountName,
      startDate,
      endDate,
      uniqueId,
      transactionId,
      status,
    } = location.state.item);
    ({ tenure, remaingTenure, interestRate, tdsRate } =
      location.state.item.fdScheme || {});
  }

  // const closeConfirmResponse = useSelector(
  //   (state) => state.goldFDCloseConfirmSlice.data.data
  // );

  // const handleCloseConfirmFD = () => {
  //   setOpen(true);
  //   dispatch(goldFDCloseConfirmApi(transactionId));
  // };
  // const handleCloseFD = () => {
  //   dispatch(goldFDCloseApi(transactionId));
  //   setOpen(false);
  //   navigate("/dashboard/history");
  // };

  return (
    <>
      {isLoading ? (
        <div style={{ height: "70vh" }}>
          <Loader />
        </div>
      ) : (
        <div className="invoice_container universal_card">
          {/* HEADER=== */}
          <div className="invoice_header">
            <div className="col-md-2 ">
              <img
                src={
                  company === "augmont"
                    ? [
                        "SPOT GOLD",
                        "GOLD BOUGHT",
                        "GOLD REDEEMED",
                        "GOLD SOLD",
                      ].includes(type)
                      ? "/images/gold_shield.png"
                      : "/images/silver_shield.png"
                    : "/images/mmtc_logo.png"
                }
                alt="goldORSilver"
                className="img-fluid"
                width="45%"
              />
            </div>
            <div
              className="text-center fw-bold"
              style={{
                marginLeft: "30%",
                fontSize: "1.3rem",
                textTransform: "uppercase",
              }}
            >
              {company}
            </div>
          </div>

          {/* JEWELLERY HISTORY=====  */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            {location.state.type === "SPOT GOLD" ? (
              spotGoldSliceResponse?.productDetails?.map((item, i) => (
                <div key={i}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>Product Name</div>
                    <div>{item.product.productName}</div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>Weight</div>
                    <div>{item.product.weight}gm</div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>Quantity</div>
                    <div>{item.quantity}</div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>Price</div>
                    <div>₹{item.orderdetails[0].finalOrderPrice}</div>
                  </div>
                  <hr style={{ border: "1px solid #510d10" }} />
                </div>
              ))
            ) : location.state.type === "fd" ? (
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>Gold Lease</div>
                  <div>{goldLease}</div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>Schema Name</div>
                  <div>{schemaName}gm</div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>User Account Name</div>
                  <div>{userAccountName}</div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>Start Date</div>
                  <div>{startDate}</div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>End Date</div>
                  <div>{endDate}</div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>Tenure</div>
                  <div>{tenure} days</div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>Remaining Tenure</div>
                  <div>{remaingTenure} days</div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>Interest Rate</div>
                  <div>{interestRate}%</div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>TDS Rate</div>
                  <div>{tdsRate}</div>
                </div>
                <hr />
              </div>
            ) : (
              <div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {type !== "GOLD REDEEMED" && type !== "SILVER REDEEMED" && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        {type.charAt(0).toUpperCase() +
                          type.slice(1).toLowerCase()}{" "}
                        rate
                      </div>

                      <div>₹{metalRate}</div>
                    </div>
                  )}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>Weight</div>
                    <div>{quantity}gm</div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>Price</div>
                    <div>₹{totalAmount}</div>
                  </div>
                </div>
                <hr style={{ border: "1px solid #510d10" }} />
              </div>
            )}

            {location.state.type != "fd" && (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h5 className="invoice_heading">Total Amount</h5>
                <h5 className="invoice_heading">
                  ₹
                  {location.state.type == "SPOT GOLD"
                    ? location?.state?.totalAmt
                    : totalAmount}
                </h5>
              </div>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "1rem",
              }}
            >
              <div style={{ textWrap: "nowrap" }}>Transaction Id</div>
              <div style={{ wordBreak: "break-all" }}>
                {location.state.type === "SPOT GOLD"
                  ? spotGoldSliceResponse?.transactionId
                  : location.state.type === "fd"
                  ? location.state.item?.transactionId
                  : historyTransactionId}
              </div>
            </div>

            {historyUniqueId ? (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div> Unique Id</div>
                <div>{historyUniqueId}</div>
              </div>
            ) : location.state.type === "fd" ? (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div> Unique Id</div>
                <div>{uniqueId}</div>
              </div>
            ) : null}

            {invoiceId && invoiceId !== "0" && (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>Invoice Number</div>
                <div>{invoiceId}</div>
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h5 className="invoice_heading">Status</h5>
              <h5
                style={{ color: "green", textTransform: "uppercase" }}
                className="invoice_heading"
              >
                {location?.state?.item?.status
                  ? location?.state?.item?.status
                  : spotGoldSliceResponse?.status}
              </h5>
            </div>
          </div>
          {location.state.type !== "SPOT GOLD" && updatedInvoicePath && (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={updatedInvoicePath || ""}
              >
                <CustomButton label="Invoice" outLined={true} />
              </a>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default HistoryInvoice;
